var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('template',{slot:"content"},[_c('help-content',{attrs:{"title":'WeRUNのデータが他社製アプリと異なる理由'}},[_c('template',{slot:"content"},[_c('div',{staticClass:"text"},[_vm._v("アプリによってデータソースやアルゴリズムが異なります。WeRUNは他のアプリからのデータを利用せず、直接携帯のセンサーよりデータを取得しています。")])])],2)],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63ff559c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Help5.vue
// module id = Voqe
// module chunks = 0